import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { useTranslate } from "react-admin";
import PaiementChancellerieModal from "./PaiementChancellerieModal";

const PaiementChancellerieModalButton = ({
    className,
    requestId,
    location,
    firstName,
    lastName,
    amount = 350,
    variant = "outlined",
    size = "small",
    children,
    ...props
}) => {
    const [open, setOpen] = useState(false);
    const translate = useTranslate();

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                color="secondary"
                onClick={handleClickOpen}
                className={className}
            >
                {children || translate("Payer {{amount}}€", { amount })}
            </Button>
            <PaiementChancellerieModal
                open={open}
                handleClose={handleClose}
                requestId={requestId}
                amount={amount}
                location={location}
                firstName={firstName}
                lastName={lastName}
            />
        </>
    );
};

export default PaiementChancellerieModalButton;
